import React from "react"
import Proptypes from "prop-types"

import { Col, Row, Button } from "reactstrap";

import Pricing1 from '../../../../images/solutions/awsTerraform/Pricing-1.png';
import Pricing2 from '../../../../images/solutions/awsTerraform/Pricing-2.png';
import Pricing3 from '../../../../images/solutions/awsTerraform/Pricing-3.png';

const featureList = [
  {
    text: 'Jitsi Meet Installation'
  },
  {
    text: 'Terraform Script'
  },
  {
    text: 'Jibri Autoscaling'
  },
  {
    text: 'User Guide'
  },
  {
    text: 'Load Balancing with HA Proxy'
  },
  {
    text: 'Auto scaling JVBs to support 500 concurrent users'
  }

]

const cardsData = [
  {
    heading: "Terraform Single Shard Deployment",
    description: "AWS",
    image: Pricing1,
    lastFeature: "Octo Setup",
    fadedLast: true,
    
  },
  {
    heading: "Kubernetes Single Shard Deployment",
    description: "AWS, GCP, Azure",
    image: Pricing2,
    lastFeature: "Octo Setup",
    fadedLast: true
    
  },
  {
    heading: "Custom Terraform or Kubernetes Jitsi Code",
    description: "Get infrastructure code fine tuned for your requirement",
    image: Pricing3,
    lastFeature: "Octo Setup",
  },
]


const CardGrid = props => {
  return (
    <div className="pricing-cards-wrapper ">
      <h2 className="heading large-font">Pricing</h2>
      <Row>
        {cardsData.map((data)=>{
          return (
            <Col md={4}>
              <div className="grid-card">
                <div>
                  <img src={data.image} />
                  <div className="heading medium-font">{data.heading}</div>
                  <div className="description small-font">{data.description}</div>
                </div>
                <div className="grid-card-body">
                  {featureList.map((feature)=>{
                    return (
                      <div className="feature-list-item small-font">{feature.text}</div>
                    )
                  })}
                  <div className={`feature-list-item small-font ${data.fadedLast && 'faded'}`}>{data.lastFeature}</div>
                  <Button color="contact-us small-font" href="/contact-us">Contact Sales</Button>
                </div>
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}



export default CardGrid
